import React from 'react';
import classes from './Logo.css';
export const Logo = (props) => {
    return (
        <div className={classes.Logo}>
            <img src='https://fivetn.com/wp-content/uploads/2018/09/logo-big-1.png' alt={'photo'}/>
        </div>
    )
}